/* Stylesheet */

.header {
  position: relative;
  height: 232px;
  background: var(--ion-gradient-dark);
  border-radius: 0% 0% 100% 0% / 0% 0% 25% 0%;
  overflow: hidden;

  .animation {
    position: absolute;
    top: 0;
    left: 50%;
    width: 50%;
    height: 100%;
    z-index: 0;
    pointer-events: none;
    opacity: 1;
  }

  .title_container {
    display: flex;
    margin: 0 auto;
    height: 100%;
    width: 75%;
    align-items: center;

    .title {
      margin: 0;
      font-size: 2.375rem;
      color: var(--ion-color-primary);
    }
  }
}

/* Media Queries */
